<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>

              <span v-if="!!id">Изменить учёные степени лица</span>
              <span v-else> <div>Создать учёные степени лица</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('academicDegree')"
              :error-messages="getError('academicDegree')"
              :items="selectors.academicDegree"
              label="Учёная степень"
              v-model="value.academicDegree"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('scientificSpecialty')"
              :error-messages="getError('scientificSpecialty')"
              :items="selectors.scientificSpecialty"
              label="Научная специальность"
              v-model="value.scientificSpecialty"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('person')"
              :error-messages="getError('person')"
              :items="selectors.person"
              label="Лицо"
              v-model="value.person"
              no-data-text ="Нет данных"
            ></v-autocomplete>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "Person_academic_degree",
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
            scientificSpecialty: Number,
            academicDegree: Number,
            person: Number,
        },
        data() {
            return {
                URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/core/models/person_academic_degree/",
                URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/core/models/person_academic_degree/<id>/",
                selectors:{
                    academicDegree:[],
                    person:[],
                    scientificSpecialty:[]
                },
                value: {
                    id: this.id || '',
                    scientificSpecialty: this.scientificSpecialty || null,
                    academicDegree: this.academicDegree || null,
                    person: this.person || null,
                },
                // errors: {}
            }
        },
        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            load: function (app, url) {
                if (url === null) {
                    app.loadingPage = true;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            app.selectors.person.push(Object.assign({}, json['results'][i]));
                        }
                        app.load(app, next_url);
                    });
            },

        },
        created() {
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_specialty/"
            this.loadSelector("scientificSpecialty",url)

            url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/academic_degree/"
            this.loadSelector("academicDegree",url)

            url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/person/"
            this.load(this, url)


        }
    }

</script>

<style scoped>

</style>
